<template>
    <div class="panel panel-default panel-sales-dashboard">
        <div class="panel-heading">
            <h5>
                {{ title }}
            </h5>
        </div>

        <loading-spinner v-if="loading"></loading-spinner>

        <div v-else class="panel-body text-center">
            <div style="font-size: 32px">
                {{ format(value) }}
            </div>

            <div v-if="compare" class="text-muted" style="font-size: 18px">
                {{ format(compareValue) }}
            </div>

            <div v-if="compare" style="font-size: 12px" :class="{'text-green': difference > 0, 'text-red': difference < 0}">
                <i v-if="difference > 0" class="fa fa-chevron-up"></i><i v-if="difference < 0" class="fa fa-chevron-down"></i> {{ difference | number }} % vs. compared data
            </div>
        </div>
    </div>
</template>

<style>
    .panel-sales-dashboard .text-green {
       color: #62d26f;
    }

    .panel-sales-dashboard .text-red {
       color: #e8384f;
    }
</style>

<script>
    import http from '@/http'
    import LoadingSpinner from '@/components/Layout/LoadingSpinner'

    export default {
        components: {LoadingSpinner},

        props: {
            title: {required: true},
            metric: {required: true},
            format: {required: true},
            compare: {required: true},
            filters: {required: true},
            compareFilters: {required: true}
        },

        data() {
            return {
                value: null,
                compareValue: null,

                loading: true
            }
        },

        watch: {
            filters() {
                this.load()
            },

            compare() {
                this.load()
            },

            compareFilters() {
                this.load()
            }
        },

        mounted() {
            this.load()
        },

        computed: {
            difference() {
                if(this.compareValue === 0) {
                    return 0
                }

                return Math.round((this.value - this.compareValue) / this.compareValue * 100)
            }
        },

        methods: {
            load() {
                this.loading = true

                Promise.all(this.getPromises())
                    .then(responses => {
                        if(responses[0].data.data.length) {
                            this.value = responses[0].data.data[0][this.metric]
                        } else {
                            this.value = 0
                        }

                        if (this.compare) {
                            if(responses[1].data.data.length) {
                                this.compareValue = responses[1].data.data[0][this.metric]
                            } else {
                                this.compareValue = 0
                            }
                        }

                        this.loading = false
                    })
            },

            getPromises() {
                let promises = [
                    http.post('/api/v1/reports/leadout-dashboard', {
                        metrics: [this.metric],
                        filters: this.filters
                    })
                ]

                if (this.compare) {
                    promises.push(
                        http.post('/api/v1/reports/leadout-dashboard', {
                            metrics: [this.metric],
                            filters: this.compareFilters
                        })
                    )
                }

                return promises
            }
        }
    }
</script>
